import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  notifications: NotificationElement[] = [];
  successConfigOptions: any = { progressBar: true };
  errorConfigOptions: any = { closeButton: true, tapToDismiss: true, disableTimeOut: true };
  warningConfigOptions: any = { closeButton: true, tapToDismiss: true, disableTimeOut: true };

  constructor(private toastr: ToastrService) { }

  showSuccess(message: string) {
    this.toastr.success(message, null, this.successConfigOptions);
  }

  showError(message: string, url: string) {
    this.notifications.push(new NotificationElement(message, url));
    this.toastr.error(message.substring(0, 500), null, this.errorConfigOptions);
  }

  showWarning(message: string) {
    this.toastr.warning(message, null, this.warningConfigOptions);
  }

  getNotifications(): NotificationElement[] {
    return this.notifications;
  }

  clearNotifications() {
    this.toastr.clear();
  }
}

export class NotificationElement {
  public dateTimeStamp: Date;
  public url: string;
  public message: string;

  constructor(message: string, url: string) {
    this.dateTimeStamp = new Date();
    this.url = url;
    this.message = message;
  }
}
